module.exports = __webpack_public_path__ + "img/Family_Packing.253235f6.jpg";